import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6">
      <div className="w-full max-w-sm border border-black p-10" data-testid="admin-login-card">
        <div className="w-12 h-12 bg-black text-white flex items-center justify-center mb-6">
          <Lock size={20} />
        </div>
        <h1 className="font-display text-2xl font-bold tracking-tight mb-1">Admin access</h1>
        <p className="text-sm text-zinc-500 mb-8">Sign in to manage products & categories.</p>

        {error && <div data-testid="login-error" className="bg-red-50 border border-red-200 text-red-700 text-sm px-4 py-2.5 mb-5">{error}</div>}

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs uppercase tracking-wider font-bold text-zinc-500">Email</label>
            <input
              data-testid="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full border border-zinc-300 focus:border-black outline-none px-3 py-2.5 mt-1.5 transition-colors"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider font-bold text-zinc-500">Password</label>
            <input
              data-testid="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full border border-zinc-300 focus:border-black outline-none px-3 py-2.5 mt-1.5 transition-colors"
            />
          </div>
          <button
            data-testid="login-submit"
            disabled={busy}
            className="w-full bg-black hover:bg-[#FF2A00] text-white py-3 font-medium transition-colors duration-300 disabled:opacity-60"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
